<div class="registerb3 contentPadding" id="ScrollingTop">
  <div class="modalb3">
    <div class="headerb3">
      <p class="spacer"></p>
      <p>{{ 'Register_Account' | t }}</p>
      <p class="spacer icon" [routerLink]="['/home']">✕</p>
    </div>

    <div class="contentb3">
      <p class="successText">{{ 'Register_Success_Desc' | t }}</p>

      <div class="submit-wrap btn-yellow" [routerLink]="['/home']">
        <button type="submit" id="submitBtnCheck" class="buttonSuccess btn-yellow">
          {{ 'Accept_Button' | t }}
        </button>
      </div>
    </div>
  </div>
</div>
